export default class PlaybackDb {
  constructor() {
    this.initializeDb();
    this.listenForTimeUpdates();
  }

  initializeDb() {
    this.initializePromise = new Promise((resolve, reject) => {
      const request = indexedDB.open('playback', 1);
      request.onerror = (event) => {
        console.error('Error initializing dtabase:', event);
        reject(event);
      };
      request.onsuccess = (event) => {
        this.db = event.target.result;
        resolve(event);
      };
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        db.createObjectStore('times', { keyPath: 'identifier' });
      };
    });
  }

  listenForTimeUpdates() {
    window.addEventListener("supercast-timeupdate", (event) => {
      const { itemType, itemId, currentTime, duration } = event.detail;
      this.logPlayback({ itemType, itemId, currentTime, duration });
    });
  }

  getPlaybackData(itemType, itemId) {
    return new Promise(async (resolve, reject) => {
      await this.initializePromise;
      const transaction = this.db.transaction('times', 'readonly');
      const store = transaction.objectStore('times');
      const request = store.get(`${itemType}-${itemId}`);
      request.onerror = (event) => {
        reject(event);
      };
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
    });
  }

  async logPlayback({ itemType, itemId, currentTime, duration }) {
    await this.initializePromise;
    const transaction = this.db.transaction('times', 'readwrite');
    const store = transaction.objectStore('times');
    store.put({
      identifier: `${itemType}-${itemId}`,
      currentTime,
      duration,
      lastPlayedAt: new Date()
    });
  }
}